import template from './ko-render-field-date.html';

class DateInputComponentVM
{
	constructor(params)
	{
		this.params = params;
		
		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.hide_labels = ko.observable(params.hide_labels);
		this.time = ko.observable(params.time || false);
		this.$input = params.$input;

		if (params.type == 'text_readonly')
			this.readonly(true);
		else
			this.readonly(false);
	}
}


export default {
	name: 'ko-render-field-date',
	viewModel: DateInputComponentVM,
	module_type: 'ko',
	template: template
}